<template>
  <section id="new-guidelines" class="inner-section steps-section">
    <div class="inner-heading">
      <h2>新手指南 <small>/guidelines</small></h2>
    </div>
    <div class="steps-grid">
      <article v-for="item in steps" :key="item.order" class="step-card">
        <div class="step-phone"><img :src="item.imgSrc" :alt="item.title + '操作界面'" /></div>
        <div class="step-copy">
          <span>{{ item.order }}</span>
          <h3>{{ item.title }}</h3>
          <p>{{ item.content }}</p>
        </div>
      </article>
    </div>
  </section>
</template>

<script>
export default {
  name: "MallGuidelines",
  data() {
    return {
      steps: [
        { imgSrc: require("@/assets/images/new-img/malls/guidelines-01.png"), order: "01", title: "注册", content: "填写详细信息，同意协议，提交完成注册" },
        { imgSrc: require("@/assets/images/new-img/malls/guidelines-02.png"), order: "02", title: "查找商品", content: "分类浏览或者直接搜索来查找商品" },
        { imgSrc: require("@/assets/images/new-img/malls/guidelines-03.png"), order: "03", title: "放入购物车", content: "点击“+”号，商品放入购物车后直接结算或者继续购物" },
        { imgSrc: require("@/assets/images/new-img/malls/guidelines-04.png"), order: "04", title: "提交订单", content: "选择支付方式(在线支付/货到付款)后，查看订单无误，提交订单" },
        { imgSrc: require("@/assets/images/new-img/malls/guidelines-05.png"), order: "05", title: "查看订单状态", content: "分为“后台确认”、“即将发货”、“已发货”三个状态" }
      ]
    };
  },
  mounted() {
    this.scrollToGuidelines();
  },
  methods: {
    scrollToGuidelines() {
      if (window.location.hash !== "#/download_app#new-guidelines") return;
      this.$nextTick(() => {
        const target = document.getElementById("new-guidelines");
        if (!target) return;
        window.scrollTo(0, target.getBoundingClientRect().top + window.pageYOffset - (window.innerWidth <= 720 ? 62 : 60));
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.inner-section {
  box-sizing: border-box;
  padding: 54px clamp(28px, 7vw, 112px) 70px;
  background: #fff;
  font-size: 16px;
  line-height: 1.5;
}

.inner-heading {
  margin-bottom: 38px;
}

h2 {
  margin: 0;
  color: #242a31;
  font-family: "PingFang SC", "Microsoft YaHei", "Noto Sans CJK SC", Arial, sans-serif;
  font-size: clamp(40px, 4.5vw, 68px);
  font-weight: 650;
  letter-spacing: -0.065em;
  line-height: 1.08;
}

h2 small {
  color: #727b87;
  font-size: 0.42em;
  font-weight: 400;
  letter-spacing: 0;
}

.steps-grid {
  display: grid;
  gap: 14px;
  grid-template-columns: repeat(5, minmax(0, 1fr));
}

.step-card {
  box-sizing: border-box;
  overflow: hidden;
  background: #fff;
}

.step-phone {
  box-sizing: border-box;
  display: flex;
  aspect-ratio: 4 / 5;
  height: auto;
  padding: 0;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background: #f7f8f5;
}

.step-phone img {
  display: block;
  width: 72%;
  max-width: 145px;
  max-height: 88%;
  height: auto;
  object-fit: contain;
}

.step-copy {
  padding: 20px 8px;
  text-align: center;
}

.step-copy > span {
  color: #78ae40;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.12em;
}

h3 {
  margin: 8px 0;
  color: #242a31;
  font-family: "PingFang SC", "Microsoft YaHei", "Noto Sans CJK SC", Arial, sans-serif;
  font-size: 17px;
  font-weight: 500;
}

p {
  margin: 0;
  color: #727b87;
  font-size: 12px;
  line-height: 1.7;
}

@media (max-width: 720px) {
  .steps-grid {
    grid-template-columns: 1fr;
  }

  .step-card {
    display: grid;
    grid-template-columns: 42% 58%;
  }

  .step-phone {
    height: auto;
    min-height: 260px;
    aspect-ratio: auto;
    padding: 24px 0;
    align-items: flex-start;
  }

  .step-phone img {
    width: 72%;
    max-width: 145px;
    max-height: none;
  }

  .step-copy {
    align-self: center;
    padding: 20px;
    text-align: left;
  }
}
</style>
